// extracted by mini-css-extract-plugin
export var sliderRange = "_qn-2";
export var sliderRoot = "_qn-0";
export var sliderThumb = "_qn-3";
export var sliderTrack = "_qn-1";